export const generateRandomPrice = (min, max) => {
  const price = Math.random() * (max - min + 1);

  return parseFloat(price.toFixed(2));
}

export default generateRandomPrice;
